import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import type { ILandingPageRenderData, ILandingPageTestimonialItem } from '@share/common-types';
import { FAKE_LANDING_TESTIMONIALS } from './landing-fake-testimonials';
import styles from './testimonials-section.module.scss';

export function getTestimonialItemsForLayout(data: ILandingPageRenderData): ILandingPageTestimonialItem[] {
  const custom = data.testimonialItems?.filter((item) => item.name?.trim() && item.quote?.trim());
  if (custom && custom.length > 0) {
    return custom;
  }
  if (data.showFakeTestimonials) {
    return [...FAKE_LANDING_TESTIMONIALS];
  }
  return [];
}

export function TestimonialsSection({ data }: { data: ILandingPageRenderData }): JSX.Element | null {
  const items = getTestimonialItemsForLayout(data);
  if (items.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.header}>
          <h2 className={styles.title}>Loved by Travelers</h2>
          <p className={styles.subtitle}>
            Join thousands of happy vacationers who have created unforgettable memories.
          </p>
        </div>
        <div className="row g-4">
          {items.map((t, i) => (
            <div key={i} className="col-12 col-md-4">
              <div className={styles.card}>
                <div className={styles.stars}>
                  {Array.from({ length: 5 }, (_, j) => (
                    <FontAwesomeIcon
                      key={j}
                      icon={faStar}
                      className={j < t.rating ? styles.starFilled : styles.starEmpty}
                      aria-hidden
                    />
                  ))}
                </div>
                <p className={styles.quote}>{t.quote}</p>
                <div className={styles.cardFooter}>
                  <p className={styles.name}>{t.name}</p>
                  {t.location ? <p className={styles.location}>{t.location}</p> : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
